import styled from 'styled-components';

import { EntityCard as DefaultEntityCard } from '@xing-com/crate-x4e-entity-card';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import { SkeletonCard as InnerSkeletonCard } from '@xing-com/skeleton';
import { scale040, spaceXXL, spaceXL, spaceL, spaceM } from '@xing-com/tokens';

const horizontalWidth = '100%';
const horizontalHeight = 'auto';
const verticalWidth = '100%';

const verticalHeight = '308px';

export const EntityCard = styled(DefaultEntityCard)`
  ${({ layout }) => layout === 'C' && `max-width: unset;`}

  @media ${mediaSmallOrTiny} {
    height: auto;
  }
`;

export const SkeletonCard = styled(InnerSkeletonCard)<{
  horizontal?: boolean;
}>`
  width: ${(props) => (props.horizontal ? horizontalWidth : verticalWidth)};
  height: ${(props) => (props.horizontal ? horizontalHeight : verticalHeight)};
  display: flex;
  padding: ${(props) => (props.horizontal ? spaceL : spaceXL)};
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  gap: ${spaceXXL};
`;
export const SkeletonProfileContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  width: ${(props) => (props.horizontal ? 'auto' : '100%')};
  justify-content: center;
  margin: ${(props) => (props.horizontal ? '0px' : spaceM)} auto 24px;
`;
export const SkeletonInfoContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 64px;
  width: 100%;
  gap: ${scale040};
`;
